import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const SubHeader = ({ title }) => {
  const navigate = useNavigate();

  return (
    // Remove the outer div and keep sticky only on the header
    <header className="sticky top-0 z-50 w-full bg-[#004990] px-4 py-4 shadow-md">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="text-white hover:bg-white/10 p-1 rounded-full"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-3 ml-4">
          <h1 className="text-white font-semibold text-lg">{title}</h1>
        </div>
      </div>
    </header>
  );
};

export default SubHeader;
